export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';
export const BYO_DIGITAL_WALLETS_GATE = 'PaymentsAccounts:EnableByoDigitalWallets';
export const CANADIAN_TAX_BREAKDOWNS_GATE = 'Commerce:CanadaSalesTax';
export const STRIPE_CONFIRMATION_TOKEN_GATE = 'Checkout:StripeConfirmationToken';